import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import config from "../../common/Config";
import { Box, Paper, Tabs, Tab, Button, Typography } from '@mui/material';
import { encryptPayload, resolveEncryptedResponse } from "../../../utils/customerCrypto";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../../../utils/companySettingsCache";

const ExportProductList = ({ totalActiveProduct, urlLink, pdtStatus }) => {

  const accessToken = localStorage.getItem('accessToken');

  const exportActiveProduct = async () => {
    const token = localStorage.getItem('token');
    const authHeader = `Bearer ${token || accessToken}`;
    const apiActivePdtUrl = `${config.API_URL}/${urlLink}`;
    const len = Number(totalActiveProduct) || 0;

    try {
      const settings = await getCompanySettings();
      const useEncrypt = resolveCustomerApiEncrypt(settings);
      let body;
      const headers = { authorization: authHeader };
      if (useEncrypt) {
        const requestData = {
          draw: 1,
          start: 0,
          length: len,
          searchValue: '',
          searchField: 'code',
          categoryValue: 0,
        };
        const encryptedPayload = encryptPayload(requestData);
        if (!encryptedPayload) {
          return;
        }
        const encForm = new FormData();
        encForm.append('encrypted_payload', encryptedPayload);
        body = encForm;
      } else {
        const formData = new FormData();
        formData.append('draw', '1');
        formData.append('start', '0');
        formData.append("length", String(len));
        body = formData;
      }

      const response = await fetch(apiActivePdtUrl, {
        method: 'POST',
        headers,
        body,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Products');
      }

      const data = await response.json();
      const decrypted = useEncrypt ? resolveEncryptedResponse(data) : null;
      const resolved =
        useEncrypt && decrypted && typeof decrypted === 'object' ? decrypted : data;

      if (!resolved?.data || !Array.isArray(resolved.data)) {
        return;
      }

      const exportData = resolved.data.map(product => ({
        Name: product.name || '',
        Code: product.code || '',
        Brand: product.brand || '',
        Category: product.categories || '',
        Size: product.size || '',
        "Unit": product.unit || '',
        "Bx Cost": product.box_cost || '',
        "Bx Price": product.price || '',
        "Pc Cost": product.piece_cost || '',
        "Pc Price": product.piece_price || '',
        "Box Quantity": product.quantity || '',
        "PC Quantity": product.split_quantity || '',
        "Tax Rate": product.rate || '',
        'bay': product.bay || '',
        'rack': product.rack || '',
        Status: product.status === '1' ? 'Active' : 'Inactive'
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Active Products');

      // Get current date and time for the filename (e.g., '2024-11-07-14-30-45')
      const now = new Date();
      const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
      const filename = `${pdtStatus}-product-list-${formattedDate}-${formattedTime}.xlsx`;


      XLSX.writeFile(wb, filename);
    } catch (error) {
      console.error('Error exporting Active Product:', error);
    }
  };

  return (
    <Box>
      <Button
        className="button-variant-outlined"
        variant="outlined"
        sx={{
          width: { xs: "100%", sm: "100%", md: "auto" },
        }}
        onClick={exportActiveProduct}
        style={{ textTransform: 'capitalize', }}>
        {/* Export {pdtStatus} Products */}
        Export
      </Button>
    </Box>
  );
};

export default ExportProductList;
